import request from '../utils/request'

// 文档相关接口
export const documentApi = {
  // 获取文档列表
  getList: (params) => request.get('/documents', { params }),
  // 获取文档详情
  getDetail: (id) => request.get(`/documents/${id}`),
  // 创建文档（包含文件上传）
  create: (data) => {
    const formData = new FormData()
    if (data.pdf) {
      formData.append('pdf', data.pdf)
    }
    formData.append('name', data.name)
    formData.append('code', data.code)
    return request.post('/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  // 更新文档
  update: (id, data) => {
    const formData = new FormData()
    if (data.pdf) {
      formData.append('pdf', data.pdf)
    }
    formData.append('name', data.name)
    formData.append('code', data.code)
    return request.put(`/documents/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  // 删除文档
  delete: (id) => request.delete(`/documents/${id}`),
}

// 用户认证相关接口
export const authApi = {
  // 登录
  login: (data) => request.post('/auth/login', data),
  // 获取用户信息
  getUserInfo: () => request.get('/auth/user'),
  // 退出登录
  logout: () => request.post('/auth/logout'),
  // 修改密码
  changePassword: (data) => request.post('/auth/change-password', data),
}
